import { Box } from '@mui/material';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OfferProgressFormatVariant, OfferProgressVariant } from '@ocx-app/components/OfferCard/offer-card.types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OfferMemberProgress } from '@ocx-app/modules/offers/earning-mechanism.types';
import React from 'react';

import { Bar } from './components/bar.component';
import { Punches } from './components/punches.component';

export const OFFER_PROGRESS_TEST_ID = 'offer-progress';

export type OfferProgressOverTimeProps = {
  progress: OfferMemberProgress;
  variant: OfferProgressVariant;
  formatVariant: OfferProgressFormatVariant;
};

export const OfferProgressOverTime = React.memo(
  ({ progress: { required, achieved }, variant, formatVariant }: OfferProgressOverTimeProps) => {
    const isPunchesVariant = variant === 'punches';

    return (
      <Box display="flex" alignSelf="stretch" data-testid={OFFER_PROGRESS_TEST_ID}>
        {isPunchesVariant ? (
          <Punches required={required} achieved={achieved} />
        ) : (
          <Bar achieved={achieved} required={required} variant={formatVariant} />
        )}
      </Box>
    );
  },
);
